document.addEventListener('DOMContentLoaded', function(){
    const wrappers = document.querySelectorAll('.PartialCollapse');

    wrappers.forEach(wrapper => {

        // get content
        const wrapperContent = wrapper.querySelector('.PartialCollapseContent');
        
        // if content is not overflowing, no collapse
        const wrapperHeight = wrapper.getBoundingClientRect().height;
        const wrapperContentHeight = wrapperContent.getBoundingClientRect().height;

        if ( wrapperContentHeight <= wrapperHeight ) {
            wrapper.classList.remove('isCollapsed');
            return;
        }
        
        // collapse wrapper and append arrow button
        wrapper.classList.add('isCollapsed');

        const arrowMarkup = createElementFromHTML(`
            <div class="PartialCollapseArrow">
                <button class="btn btn-link w-100">
                    <svg class="icon-chevron-down-light text-secondary">
                        <use xlink:href="#icon-chevron-down-light"></use>
                    </svg>
                </button>
            </div>
        `);

        wrapper.append(arrowMarkup);

        arrowMarkup.addEventListener('click', function(e){
            // after arrow button is clicked
            e.preventDefault();

            if ( wrapper.classList.contains('isCollapsed') )
            {
                // remove collapse
                wrapper.classList.remove('isCollapsed');

                // scroll to wrapper
                window.scrollTo({
                    top: wrapper.getBoundingClientRect().top + window.scrollY - (document.querySelector('.MainHeader').getBoundingClientRect().height + 30), 
                    behavior: 'smooth'
                });
            }
            else
            {
                // add collapse
                wrapper.classList.add('isCollapsed'); 
            }
        });

    });
});

function createElementFromHTML(htmlString) {
    // crate and retrun virtual element node from html string
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    return div.firstChild;
}